import React from 'react';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={styles.privacyPage}>
      <div className={styles.privacyContent}>
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last updated: May 2, 2025</p>

        <section>
          <h2 className={styles.sectionTitle}>1. Introduction</h2>
          <p>
            Orbsway values your privacy and is committed to protecting your personal information. This Privacy Policy outlines how we collect, use, store, and protect your data when you use our services, including user authentication and Google Meet integration. By using our app, you agree to the terms of this policy.          </p>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>2. Information We Collect</h2>
          <p>We may collect the following types of data:</p>
          <ul>
            <li>Email address and name (via Google OAuth)</li>
            <li>Google Meet metadata (meeting titles, IDs, timestamps)</li>
            <li>Device and browser data for performance monitoring</li>
            <li>Eye health data (with personal consent)</li>
          </ul>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>3. How We Use Your Data</h2>
          <p>We use the collected data:</p>
          <ul>
            <li>To authenticate and authorize users securely</li>
            <li>To create, manage, and monitor Google Meet sessions</li>
            <li>To optimize performance and ensure application stability</li>
            <li>To analyze anonymized health data for improving visual wellness features</li>
            <li>To comply with legal obligations and ensure platform integrity</li>
          </ul>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>4. Data Sharing</h2>
          <p>We do not sell, rent, or trade your personal data to third parties. Data is only shared under the following circumstances:</p>
          <ul>
            <li>With Google APIs for authentication and Google Meet functionality</li>
            <li>With trusted service providers who help us maintain our infrastructure (under strict confidentiality agreements)</li>
            <li>With all third parties we work with must adhere to strict data protection standards.</li>
          </ul>        
        </section>

        <section>
          <h2 className={styles.sectionTitle}>5. Data Security</h2>
          <p>We take data protection seriously. Orbsway uses:</p>
          <ul>
            <li>Secure data storage with limited access</li>
            <li>Regular security audits and updates to protect against vulnerabilities</li>
            <li>Industry-standard protocols like HTTPS and OAuth 2.0</li>
            <li>Role-based access control (RBAC) to limit data access internally</li>
          </ul>        
        </section>

        <section>
          <h2 className={styles.sectionTitle}>6. Your Rights</h2>
          <p>You have the right to access, correct, or delete your personal data. You may revoke Google permissions at any time through your Google account settings.</p>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>7. Changes to This Policy</h2>
          <p>We may update this Privacy Policy periodically. We will notify users of any major changes.</p>
        </section>

        <section>
          <h2 className={styles.sectionTitle}>8. Contact Us</h2>
          <p>If you have any questions or concerns about this Privacy Policy, contact us at <a href="mailto:help@orbsway.com">help@orbsway.com</a>.</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
